import * as actions from './../actions/notify.actions';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { map } from 'rxjs/operators';
import { MwNotificationService } from '@core/services';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class NotifyEffects {
  notifySuccess$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.notifySuccess),
        map((action) =>
          this.notificationService.success(
            this.translateService.instant(action.notification.phrase)
          )
        )
      ),
    { dispatch: false }
  );

  notifyError$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(actions.notifyError),
        map((action) =>
          this.notificationService.error(
            this.translateService.instant(action.notification.phrase)
          )
        )
      ),
    { dispatch: false }
  );

  constructor(
    private actions$: Actions,
    private translateService: TranslateService,
    private notificationService: MwNotificationService
  ) {}
}
